export const CATEGORY_QUERY = `
  query GetCategory($slug: String!) {
    category(slug: $slug) {
      id
      name
      slug
      meta_title
      meta_description
      image_path
      banner_path
      children {
        id
        name
        slug
        __typename
      }
      __typename
    }
  }
`;

export const PRODUCTS_BY_CATEGORY_QUERY = `
  query GetProductsByCategory(
    $category_id: String!,
    $page: Int,
    $first: Int,
    $sort_by: String,
    $sort_dir: String,
    $min_price: Float,
    $max_price: Float,
    $name: String
  ) {
    productsByCategory(
      category_id: $category_id,
      page: $page,
      first: $first,
      sort_by: $sort_by,
      sort_dir: $sort_dir,
      min_price: $min_price,
      max_price: $max_price,
      name: $name
    ) {
      data {
        id
        name
        slug
        main_image_url
        price
        final_price
        type
        min_order_qty
        min_logo_qty
        delivery_date
        variants {
          id
          name
          sku
          price
          final_price
          stock
          __typename
        }
        __typename
      }
      pagination {
        current_page
        has_more_pages
        total
        per_page
        __typename
      }
      __typename
    }
  }
`;

export const ROOT_CATEGORIES_QUERY = `
  query GetRootCategories {
    allCategory {
      id
      name
      slug
      meta_title
      meta_description
      image_path
      banner_path
      children {
        id
        name
        slug
        __typename
      }
      __typename
    }
  }
`;

export const CUSTOMER_QUERY = `
  query GetCustomer {
    customerQuery {
      id
      email
      name
      phone
      group {
        id
        name
        __typename
      }
      branches {
        id
        name
        address
        __typename
      }
      __typename
    }
  }
`;
